module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/Fullscreen-9f4f9601bbf34928d42095fac5e9ef1b.jpg";